import * as React from "react";
import styled from "styled-components";
import Badge from "components/bootstrap/Badge";
const StyledBadge = styled(Badge)`
  vertical-align: top;
`;
const BetaBadge = () => /* @__PURE__ */ React.createElement(StyledBadge, { bsStyle: "danger" }, "Beta");
export default BetaBadge;
